import { useState } from 'react';
import { useToast } from '../../context/ToastProvider.js';
import './../../styles/Modal.css';

function LoadProductTemplateModal({
    savedTemplates,
    onClose,
    onLoadedTemplate,
    currentConfig,
    productHandle
}) {
    const addToast = useToast();
    const [ tempSavedTemplates , setTempSavedTemplates ] = useState( savedTemplates );
    const [ sortedTemplates , setSortedTemplates ] = useState( sortTemplatesByCategory( tempSavedTemplates ) );
    const [ selectedCategory, setSelectedCategory ] = useState( "" );
    const [ selectedTemplateId, setSelectedTemplateId ] = useState( -1 );

    function sortTemplatesByCategory( templates ) {
        const sortedTemplates = {};

        for ( let i = 0; i < templates.length; i++ ) {
            const category = templates[i].category;

            if ( typeof( sortedTemplates[category] ) === 'undefined' ) {
                sortedTemplates[ category ] = [];
            }

            sortedTemplates[ category ].push( templates[i] );
        }

        return sortedTemplates;
    }

    function loadTemplateFromSavedConfig( selectedCategory , selectedTemplateId ) {
        const categorySelected = sortedTemplates[ selectedCategory ];
        const currentConfigCopy = structuredClone( currentConfig );
        
        let selectedTemplateConfig = null;
        for ( let i = 0; i < categorySelected.length; i++ ) {
            if ( categorySelected[i].id == selectedTemplateId ) {
                selectedTemplateConfig = categorySelected[i];
                break;
            }
        }


        // compare the options in the savedTemplates' saved_config to the currentConfig
        const selectedFrontConfig = selectedTemplateConfig.saved_config['front'] || {};
        const selectedBackConfig = selectedTemplateConfig.saved_config['back'] || {};
        const currentFrontConfig = currentConfigCopy['front'] || {};
        const currentBackConfig = currentConfigCopy['back'] || {};

        const selectedFrontConfigEntries = Object.entries( selectedFrontConfig );
        const selectedBackConfigEntries = Object.entries( selectedBackConfig );

        for ( const [ optionHandle , layers ] of selectedFrontConfigEntries ) {
            // if handle from selected is in current, save the layers
            if ( currentFrontConfig[ optionHandle ] ) {
                for ( let i = 0; i < layers.length; i++ ) {
                    layers[i].related_product_handle = productHandle;
                }
                currentFrontConfig[ optionHandle ] = layers;
            }
        }

        for ( const [ optionHandle , layers ] of selectedBackConfigEntries ) {
            // if handle from selected is in current, save the layers
            if ( currentBackConfig[ optionHandle ] ) {
                for ( let i = 0; i < layers.length; i++ ) {
                    layers[i].related_product_handle = productHandle;
                }
                currentBackConfig[ optionHandle ] = layers;
            }
        }

        if ( typeof( onLoadedTemplate ) === 'function' ) {
            onLoadedTemplate( currentConfigCopy );
        }

        return currentConfigCopy;
    }
    
    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <h1>Load Product Template</h1>
                <p>
                    Looks like this product doesn't have any layers configured yet. 
                    You can load a saved template or create a new configuration from scratch.
                </p>

                {Object.keys( sortedTemplates ).length > 0 && 
                     <div className="form-group">
                        {/* Category Dropdown */}
                        <label>Category</label>
                        <select
                            value={selectedCategory}
                            onChange={ (e) => {
                                setSelectedCategory(e.target.value);
                                setSelectedTemplateId(-1);
                            }}
                        >
                            <option value="" disabled>Select a Category</option>
                            {Object.keys(sortedTemplates).map( ( category ) => (
                                <option key={category} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>
                }

                {Object.keys( sortedTemplates ).length <= 0 && 
                    <p><em>No templates are currently available to load from. Click Skip to continue.</em></p>
                }
               

                {/* Template Dropdown (Only show if category is selected) */}
                { selectedCategory && (
                    <div className="form-group">
                        <label>Template</label>
                            <select
                                value={selectedTemplateId}
                                onChange={ ( e ) => setSelectedTemplateId( parseInt( e.target.value ) ) }
                            >
                                <option value={-1} disabled>Select a Template</option>
                                {sortedTemplates[selectedCategory].map((template) => (
                                    <option key={template.id} value={template.id}>
                                        {template.name}
                                    </option>
                                ))}
                            </select>
                    </div>
                )}


                <div className="modal-controls">
                    <button type="button" className="cancel-btn" onClick={onClose}>
                        Skip
                    </button>
                    <button
                        type="button"
                        className="done-btn"
                        disabled={ selectedCategory === "" || selectedTemplateId === -1 }
                        onClick={ ( ) => loadTemplateFromSavedConfig( selectedCategory , selectedTemplateId ) }
                    >
                        Load Template
                    </button>
                </div>
            </div>
        </div>
    )
}

export default LoadProductTemplateModal;